<template>
  <article class="mobile-center">
    <section class="fw-section">
      <div>
        <div class="container fullwidthsec1">
          <div class="simplelist">
            <div class="top-menu">
              <div class="container fullwidthsec" style="padding: 0px">
                <div class="row">
                  <div
                    class="col-2 simplelistimg"
                    style="margin: 0px; padding: 0px"
                  >
                    <img
                      alt=""
                      class="custom-logo"
                      src="@/assets/img2/logo72.png"
                      style="
                        cursor: pointer;
                        height: 64px;
                        width: 64px;
                        margin-top: 10px;
                      "
                      onclick="window.location.href='/';"
                    />
                  </div>
                  <div class="col-10 text-right horizontal-list">
                    <router-link to="/plans">Pricing</router-link>

                    <a href="https://support.maposcope.com/en/">Help</a>
                    <router-link to="/contact">Contact</router-link>

                    <button
                      class="btn btnl2 btn-sm btn-ghost"
                      @click="gotologin"
                      v-on:click.stop
                      type="submit"
                      style="font-size: 14px; color: #2c405a"
                    >
                      <i
                        class="material-icons person_outline text-default"
                        style="
                          font-size: 14px;
                          padding-bottom: 15px;
                          color: #2c405a;
                        "
                      ></i>

                      <span style="padding: 5px; color: #2c405a">Log in</span>
                    </button>
                    <button
                      class="btn btnl1 btn-sm btn-ghost"
                      @click="gotoregister()"
                      v-on:click.stop
                      type="submit"
                      style="font-size: 14px"
                    >
                      <i
                        class="material-icons person_outline text-default"
                        style="
                          font-size: 14px;
                          padding-bottom: 5px;
                          color: #ffffff;
                        "
                      ></i>
                      Start free trial
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </article>
</template>

<script>
export default {
  methods: {
    gotologin() {
      this.$router.push({
        name: "Login",
      });
    },
    gotoregister() {
      this.$router.push({
        name: "Signup",
      });
    },
  },
};
</script>

<style scoped>
.fullwidthsec {
  max-width: 1200px;
}
.btnl1 {
  color: #ffffff !important;
  background-color: #1972f5;
}

.btnl1:hover {
  background-color: #0a64eb;
}

.btnl2 {
  color: #ffffff !important;
  background-color: #eceff6;
}

.btnl2:hover {
  background-color: #eceff6;
}
</style>